var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuitcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.224,
    height: 21.113,
    viewBox: "0 0 22.224 21.113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-work",
    "data-name": "Icon material-work",
    d: "M23,7.445H18.557V5.222A2.215,2.215,0,0,0,16.334,3H11.889A2.215,2.215,0,0,0,9.667,5.222V7.445H5.222A2.205,2.205,0,0,0,3.011,9.667L3,21.89a2.215,2.215,0,0,0,2.222,2.222H23a2.215,2.215,0,0,0,2.222-2.222V9.667A2.215,2.215,0,0,0,23,7.445Zm-6.667,0H11.889V5.222h4.445Z",
    transform: "translate(-3 -3)",
    fill: "#716f6f80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.24eab218bcbe3197c0b0c1f7db7ba5d8.svg";
export { ForwardRef as ReactComponent };